import type { ComprehensiveScenario } from '../../types/scenarios';

export type ScenarioCategory = 'growth' | 'cost-cutting' | 'crisis' | 'custom';

/**
 * Category defaults to 'custom' when a scenario has no explicit category set.
 * Shared by ScenarioCard and the scenario list row so both render the same label.
 */
export function resolveCategory(
  scenario: Pick<ComprehensiveScenario, 'category'>,
): ScenarioCategory {
  return (scenario.category as ScenarioCategory) ?? 'custom';
}

export const categoryLabels: Record<ScenarioCategory, string> = {
  growth: 'Growth',
  'cost-cutting': 'Cost-Cutting',
  crisis: 'Crisis',
  custom: 'Custom',
};
